//import cookie from '../utils/cookie'
import { keepTwodecimalFull } from '../utils/util'
import AmountHelper from '@/utils/amountHelper'
import cookie from '@/utils/cookie'

let app = {
    methods: {
        getPackageDetail(goodsCode) {
            return new Promise((resolve, reject) => {
                let url = '/bss/app/noauth/QueryOfferList',
                    reqParams = {
                        channelType: this.$APP_CONFIG.request.channelType,
                        goodsCode,
                        queryPromotionFlag: true,
                        queryLimitFlag: true,
                        goodsExtendAttrs:["hideFlowSize"]
                    };

                this.$http.post({
                    url,
                    data: {
                        ...reqParams
                    }
                }).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            })
        },
        getCoverListMixin() {
            return new Promise((resolve, reject) => {
                this.$http.post({
                    url: '/bss/app/noauth/QueryCoverCountyInfo'
                }).then(res => {
                    resolve(res)                                     
                }).catch(err => {
                    reject(err)
                })
            })
        },
        globalPriceFormat(currencyType, price) {              
            let lowerCurrency = currencyType.toLowerCase();
            let codeType = this.$APP_CONFIG.currencyTypeMap[lowerCurrency] ? this.$APP_CONFIG.currencyTypeMap[lowerCurrency] : currencyType;
            let langType = cookie.getCookie('langType')
            // 部分欧洲国家小数点采取 ， 形式
            let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
            if(lowerCurrency == 'jpy') {                
                let s_price = AmountHelper.centiAmount(price, 2);
                if(isNaN(s_price)){
                    return "";
                }              
                return `${codeType} ${s_price.toLocaleString()}`;
            } else {
                let showPrice = keepTwodecimalFull(AmountHelper.centiAmount(price, 2))
                if(country.includes(langType)){
                    showPrice = (showPrice + '').replace('.',',')
                }
                return `${codeType} ${showPrice}`;
            }
        }
    }
}

export const global = {
    app
};